export const ERROR_GENERIC = 'An error occurred while processing the request';

export const RESOURCE_NOT_FOUND = 'Resource not found';

export const SUCCESS_GENERIC = 'Success';
